import { InjectionToken } from '@angular/core';

/**
 * Use this to add a new style tag to the header
 */
export const createStyle = (document: Document, css: string, id?: string) => {
    // https://stackoverflow.com/a/46079845
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    if (id) {
        style.id = id;
    }

    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
};

export type CreateStyleProvider = (document: any, css: string, id?: string) => void;
export const CREATE_STYLE =
    new InjectionToken('CREATE_STYLE', {
        factory: () => createStyle
    });
